<template>
  <!-- 1.展示礼品 -->
  <!-- 2.选择礼品  存到本地-->
  <div class="goods_container">
    <div class="nav">
      <div
        class="nav_item"
        :class="addressUid == item.uid ? 'active' : ''"
        @click="onAddressChange(item.uid)"
        v-for="item in addressList"
        :key="item.uid"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="goods_list">
      <div class="sort">
        <div
          class="sort_item "
          @click="sort('sales')"
          :class="sortType == 'sales' ? 'active' : ''"
        >
          <span>销量</span>
          <van-icon
            name="play"
            class="sort_icon"
            :class="sortType == 'sales' ? 'active' : ''"
          />
        </div>
        <div
          class="sort_item"
          @click="sort('price')"
          :class="sortType == 'price' ? 'active' : ''"
        >
          <span>价格</span>
          <van-icon
            name="play"
            class="sort_icon"
            :class="sortType == 'price' ? 'active' : ''"
          />
        </div>
        <div
          class="sort_item"
          @click="sort('weight')"
          :class="sortType == 'weight' ? 'active' : ''"
        >
          <span>重量</span>
          <van-icon
            name="play"
            class="sort_icon"
            :class="sortType == 'weight' ? 'active' : ''"
          />
        </div>
      </div>
      <div class="list">
        <div
          class="good_item"
          v-for="item in goodsList"
          :key="item.id"
          @click="handleChooseGood(item)"
        >
          <div class="left">
            <img :src="item.picture" alt="" />
          </div>
          <div class="rig">
            <div class="title">
              {{ item.name }}
            </div>
            <div class="desc">
              <div class="weight">{{ Number(item.weight) * 1000 }}g/件</div>
              <div class="site">
                {{ addressObj[item.uid] }}
              </div>
            </div>
            <div class="price">
              <span>￥</span>
              <span class="money"> {{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addressList, goodsListAll, addressLogisticsListByUser } from '@/api';
import Vue from 'vue';
export default {
  data() {
    return {
      activePlatForm: '',
      addressList: [],
      addressUid: '',
      goodsList: [],
      goodsListClone: [],
      addressObj: {},
      sortType: '',
      sortFlag: true
    };
  },
  methods: {
    getAddressObj() {
      addressList('').then((res) => {
        let obj = {};
        res.data.forEach((item) => {
          let uid = item.uid;
          let site = item.province + item.city.split('【')[0];
          obj[uid] = site;
        });
        this.addressObj = obj;
      });
    },
    getAddressListAll(type) {
      addressList(type).then((res) => {
        if (res.success) {
          this.addressList = res.data;
          this.addressUid = this.addressList[0].uid;
          this.getGoodsListAll();
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    onAddressChange(uid) {
      this.addressUid = uid;
      this.getGoodsListAll();
    },
    getGoodsListAll() {
      const params = {
        pageNum: 1,
        pageSize: 100,
        uid: this.addressUid
      };
      goodsListAll(params).then((res) => {
        if (res.success) {
          this.goodsList = res.data.list;
          this.goodsListClone = res.data.list;
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    handleChooseGood(item) {
      addressLogisticsListByUser(item.uid).then((res) => {
        //运费  快递公司  快递id  礼品仓库
        item.deliveryPrice = res.data[0].price;
        item.deliveryName = res.data[0].name;
        item.logisticsId = res.data[0].id;
        item.site = this.addressObj[item.uid];
        Vue.ls.set('goodInfo', item);
        this.$router.push({ path: '/buy' });
      });
    },
    //排序
    sort(type) {
      this.sortType = type;
      if (!this.sortFlag) {
        let list = JSON.parse(JSON.stringify(this.goodsListClone));
        this.goodsList = list.sort((a, b) => {
          return b[type] - a[type];
        });
      } else {
        let list = JSON.parse(JSON.stringify(this.goodsListClone));
        this.goodsList = list.sort((a, b) => {
          return a[type] - b[type];
        });
      }
      this.sortFlag = !this.sortFlag;
    }
  },
  mounted() {
    //获取平台
    this.activePlatForm = this.$route.query.type;
    //获取支持仓库
    this.getAddressListAll(this.activePlatForm);
    //获取仓库对象
    this.getAddressObj();
  }
};
</script>

<style lang="less" scoped>
.goods_container {
  display: flex;
}
.nav {
  width: 21.333vw;
  background: #f2f3f5;
  height: 100vh;

  &_item {
    padding: 5.333vw 3.2vw;
    background: #f7f8fa;
    font-size: 3.467vw;
    line-height: 4.533vw;
    color: #7d7e80;
  }
  .active {
    background: #ffffff;
  }
}
.goods_list {
  flex: 1;
  .sort {
    display: flex;
    &_item {
      flex: 1;
      height: 12.8vw;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-right: 1.067vw;
      }
      .sort_icon {
        transform: rotate(90deg);
        font-size: 8px;
        color: #dcdee0;
      }
    }
    .active {
      color: #f93244;
    }
  }
  .list {
    height: calc(100vh - 48px);
    overflow: auto;
    .good_item {
      display: flex;
      height: 27.733vw;
      padding: 3.2vw;
      .left {
        width: 21.333vw;
        height: 21.333vw;
        border-radius: 1.067vw;
        margin-right: 2.133vw;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .rig {
        margin-top: 1.067vw;
        .title {
          font-size: 4vw;
          color: #333333;
          margin-bottom: 1.6vw;
          font-weight: 500;
        }
        .desc {
          color: #999999;
          margin-bottom: 5.867vw;
          display: flex;
          .weight {
            margin-right: 4.8vw;
            font-size: 3.2vw;
          }
          .site {
            font-size: 3.467vw;
          }
        }
        .price {
          font-family: Avenir-Heavy;
          font-weight: 550;
          color: #323233;
          .money {
            font-size: 4.533vw;
          }
        }
      }
    }
  }
}
</style>
